import { render } from "./AllocatedAccomplishedMain.vue?vue&type=template&id=0658c8b9&scoped=true&ts=true"
import script from "./AllocatedAccomplishedMain.vue?vue&type=script&lang=ts"
export * from "./AllocatedAccomplishedMain.vue?vue&type=script&lang=ts"

import "./AllocatedAccomplishedMain.vue?vue&type=style&index=0&id=0658c8b9&lang=scss&scoped=true"

import exportComponent from "/home/node/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0658c8b9"]])

export default __exports__